export default function log({
    next,
    // eslint-disable-next-line no-unused-vars
    to
}) {
    // console.log("Admin Log", this.$store.state.auth.user.is_admin)
    // console.log("Admin Log", to.name);
    return next();
}